import CoreInstance from '../CoreInstance';

const organizations = {
  // ..
};

const centers = {
  getInitialAssessment: (babyId, initialAssessmentId) => CoreInstance.get(`/centers/babies/${babyId}/initial_assessments/${initialAssessmentId}`),
  deleteInitialAssessment: (babyId, initialAssessmentId) => CoreInstance.delete(`/centers/babies/${babyId}/initial_assessments/${initialAssessmentId}`),
  putInitialAssessment: (babyId, initialAssessmentId, body) => CoreInstance.put(`/centers/babies/${babyId}/initial_assessments/${initialAssessmentId}`, body),
};

export default {
  organizations,
  centers,
};
